// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG
export default {
    AWS_REGION: CONFIG.AWS_REGION,
    USER_POOL_ID: CONFIG.USER_POOL_ID,
    USER_POOL_APP_CLIENT_ID: CONFIG.USER_POOL_APP_CLIENT_ID,
    COGNITO_REDIRECT_SIGN_IN: CONFIG.COGNITO_REDIRECT_SIGN_IN,
    COGNITO_REDIRECT_SIGN_OUT: CONFIG.COGNITO_REDIRECT_SIGN_OUT,
    COGNITO_DOMAIN: CONFIG.COGNITO_DOMAIN,
    COGNITO_RESPONSE_TYPE: CONFIG.COGNITO_RESPONSE_TYPE,
}
